module.exports = __webpack_public_path__ + "images/billing-selection-bg.png";